/* eslint-disable prettier/prettier */
import React from "react";
import {
  notifyViewFinishedLoading,
  getCurrentInstance,
  appDefIds,
  PageComponentId,
} from "@wix/business-manager-api";
import { create } from "@wix/fedops-logger";
import {
  COMPONENT_NAME,
  DEALER_SERVICE_BASE_URL,
  IBMModuleParams,
  WORKFLOW_SERVICE_BASE_URL,
  INBOX_SETTINGS_URLS,
  APP_MARKET_URLS,
} from "../../config";
import CrmHome from "../crm-home/CrmHome";
import { initTools } from "../crm-home/tools";
import { CrmHomeBiLogger } from "../../bi-logger";
import Experiments from "@wix/wix-experiments";
import { DealerService } from "../../services/dealer.service";
import { WorkflowService } from "../../services/workflows.service";
import { ContactsService } from "../../services/contacts.service";
import { IntegrationsService } from "../../services/integration.service";
import {
  CrmHomeBannerOffer,
  CrmButtonActionType,
  CardDealerOffer,
  FinanceAppData,
} from "../../types";
import _ from 'lodash'
import { FontUpgrade } from "wix-style-react";

interface AppProps {
  biLogger: CrmHomeBiLogger;
  moduleParams: Partial<IBMModuleParams>;
}

interface AppState {
  experiments: Experiments;
  banner: CrmHomeBannerOffer;
  cards: CardDealerOffer[];
  widgetInitData: {contacts:any};
  connections: {[x:string]: boolean};
  financeIntegrationData: FinanceAppData[];
  useNewFonts: boolean;
}

class App extends React.Component<AppProps, AppState> {
  private readonly instance: string;
  private readonly dealerService: DealerService;
  private readonly workflowService: WorkflowService;
  private readonly contactsService: ContactsService;
  private readonly integrationsService: IntegrationsService;

  constructor(props: AppProps) {
    super(props);

    this.instance = getCurrentInstance(appDefIds.metaSite);

    this.dealerService = new DealerService(
      DEALER_SERVICE_BASE_URL,
      this.instance
    );
    this.workflowService = new WorkflowService(
      WORKFLOW_SERVICE_BASE_URL,
      this.instance
    );
    this.integrationsService = new IntegrationsService(
      INBOX_SETTINGS_URLS.baseUrl,
      APP_MARKET_URLS.baseUrl,
      this.instance,
      props.moduleParams.metaSiteId!
    );

    this.contactsService = new ContactsService(this.instance);


    this.state = {
      experiments: new Experiments(),
      banner: {
        offerName: "inbox",
        title: "banner.inbox.title",
        body: "banner.inbox.body",
        mainButtonText: "banner.inbox.mainButtonText",
        illustration: "",
        mainButtonConfig: {
          key: "somekey",
          value: {
            type: CrmButtonActionType.NAVIGATE,
            payload: {
              pageComponentId: PageComponentId.Engage,
              contextData: {
                appState: "?referralInfo=crm-home_section-tool-cards_inbox",
              },
            },
          },
        },
      },
      cards: [],
      connections: {},
      widgetInitData: { contacts: null },
      financeIntegrationData: [],
      useNewFonts: false,
    };
  }

  async componentDidMount() {
    const fedopsLogger = create(COMPONENT_NAME);

    await this.fethcData();
    fedopsLogger.appLoaded();
    notifyViewFinishedLoading(COMPONENT_NAME);

  }



  private getOffetPayload(bannerData) {
    if (bannerData && bannerData.offers && bannerData.offers.length) {
      return {
        offerName: bannerData.offers[0].offerName,
        ...JSON.parse(bannerData.offers[0].asset!.payloadJson),
      };
    }
  }
  private parseCards(cardData) {
    if (cardData && cardData.offers && cardData.offers.length) {
      return cardData.offers.map((offer) => ({
        offerName: offer.offerName,
        ...JSON.parse(offer.asset!.payloadJson),
      }));
    }
  }

  private async fethcData() {
    const USSite = this.props.moduleParams.primarySiteLocale === "en-us";

    const experiments = new Experiments({ scope: "business-manager" });
    const experimentsReady = experiments.ready();
    const getBannerPromise = this.dealerService.getBanner();
    const cardsPromise = this.dealerService.getCards();
    const contactWidgetDataPromise = this.contactsService.getWidgetData();
    const getConnections = this.integrationsService.getConnections();
    const getFinanceIntegration = this.integrationsService.getFinanceIntegrationData();

    const [
      bannerData,
      cardsData,
      contactWidgetData,
      connections,
      financeIntegrationData,
    ] = await Promise.all([
      getBannerPromise,
      cardsPromise,
      contactWidgetDataPromise,
      getConnections,
      USSite ? getFinanceIntegration : Promise.resolve([]),
      experimentsReady,
    ]);
    const banner = this.getOffetPayload(bannerData);
    const cards = this.parseCards(cardsData);
    const widgetInitData = { contacts: contactWidgetData };
    this.setState({
      experiments,
      banner: banner || this.state.banner,
      cards,
      widgetInitData,
      connections,
      financeIntegrationData,
      useNewFonts: experiments.enabled('specs.crm.HomeNewFonts')
    });
  }

  render() {
    const tools = initTools();
    return (
      <FontUpgrade active={this.state.useNewFonts}>
        <CrmHome
          moduleParams={this.props.moduleParams}
          tools={tools}
          biLogger={this.props.biLogger}
          experiments={this.state.experiments}
          banner={this.state.banner}
          cards={this.state.cards}
          connections={this.state.connections}
          widgetInitData={this.state.widgetInitData}
          services={{
            workflows: this.workflowService,
          }}
          financeIntegrationData={this.state.financeIntegrationData}
        />
      </FontUpgrade>
    );
  }
}

export default App;
